const plan_tabs = () => {
    $('.plan-tabs-module .plan-button').on('click', function() {
        let $this = $(this);

        if ( !$this.hasClass('active') ) {
            let planIndex = $this.data('plan-index');
            let $container = $this.parent().parent();

            $container.find('.plan-button').removeClass('active');
            $this.addClass('active');
            $container.find('.plan-info').hide();
            $container.find('.plan-info[data-plan-index="' + planIndex + '"]').fadeIn();
        }
    });
}

export default plan_tabs;